import type { Dictionary } from './dictionary';

/** Slovník UA – převzato z prototypu, doplněné klíče přeloženy ve stejném stylu. */
export const uk: Dictionary = {
  app: 'Склад',
  logoutA: 'Вийти',

  idLbl: 'Номер посилки',
  seq: 'Порядок',
  nav: 'Навігація',
  count: 'Кількість посилок',
  weight: 'Вага',
  edit: 'Змінити',
  date: 'Дата',
  driver: 'Водій',
  vehicle: 'Транспорт',
  zone: 'Зона',
  routeNo: 'Номер маршруту',
  deliveryTime: 'Час',
  scanned: 'Відсканований код',
  scannedBy: 'Зчитано складом',
  noWeight: '— кг',
  addWeight: 'Додати вагу',

  until: 'Доставка лише',
  dayLbl: 'День доставки',
  notSet: 'Ще не визначено',
  expedFrom: 'Буде відправлено зі складу',

  chill: 'ОХОЛОДЖЕНЕ',
  frozen: 'ЗАМОРОЖЕНЕ',

  trCZ: 'ВІДПРАВИТИ ДО ЧЕХІЇ',
  trSK: 'ВІДПРАВИТИ ДО СЛОВАЧЧИНИ',
  trNoteCZ: 'Посилку необхідно перевезти до Чехії.',
  trNoteSK: 'Посилку необхідно перевезти до Словаччини.',
  loadToday: 'ЗАВАНТАЖИТИ СЬОГОДНІ',
  confirmTr: 'Підтвердити перевезення',
  trValCZ: 'Перевезено до Чехії',
  trValSK: 'Перевезено до Словаччини',
  confirmTitle: 'Підтвердити перевезення між складами',
  confirmNote: 'Підтвердженням до замовлення буде записано: «{W}».',
  notFinal: 'Це не кінцевий стан.',

  pkgLbl: 'Посилка',
  ofN: 'з',
  kompLbl: 'Комплектація замовлення',
  kompDone: 'ПОСИЛКА ПОВНІСТЮ ВІДСКАНОВАНА',
  kompTodo: 'ЩЕ НЕОБХІДНО ВІДСКАНУВАТИ',

  retry: 'Повторна спроба',
  part: 'Доставити другу частину',

  scanNext: 'Сканувати далі',
  report: 'ПОВІДОМИТИ ДИСПЕТЧЕРА',
  reported: 'Повідомлено диспетчерів',
  findManual: 'ЗНАЙТИ ВРУЧНУ',

  reportTitle: 'Повідомити диспетчера',
  reasonLbl: 'Причина',
  byState: 'ЗА СТАНОМ',
  r_zrusena: 'Посилка вже скасована',
  r_dorucena: 'Посилка вже доставлена',
  r_vracena: 'Посилка вже повернена відправнику',
  r_jiny: 'Інша причина – опиши в примітці',
  noteReq: 'Примітка (обов’язково)',
  noteOpt: 'Примітка (необов’язково)',
  notePh: 'Напр. посилка пошкоджена, етикетка нерозбірлива…',
  send: 'Надіслати',
  sending: 'Надсилаю…',
  cancel: 'Скасувати',
  errReason: 'Вибери причину.',
  errNote: 'Для іншої причини додай примітку.',

  findTitle: 'Знайти вручну',
  orderNo: 'Номер замовлення',
  orderPh: 'Введи номер замовлення',
  search: 'Шукати',
  searching: 'Шукаю…',
  errQuery: 'Введи номер замовлення.',

  loginTitle: 'Вхід',
  loginSubtitle: 'Увійди, щоб продовжити',
  loginName: 'Ім’я',
  loginPin: 'PIN',
  loginSubmit: 'Увійти',
  loginPending: 'Входжу…',
  loginErrEmpty: 'Заповни ім’я та PIN.',
  loginErrFailed: 'Не вдалося увійти.',

  scanTitle: 'Сканування коду',
  scanHint: 'Наведи камеру на QR або штрихкод.',
  scanStart: 'Запустити сканер',
  scanStop: 'Зупинити сканер',
  scanStarting: 'Запускаю камеру…',
  scanCameraErr: 'Не вдалося запустити камеру.',
  scanLoading: 'Завантажую дані посилки…',
  manualTitle: 'Або введи код вручну',
  manualPh: 'Номер посилки',
  manualSubmit: 'Знайти',

  errLoad: 'Не вдалося завантажити посилку.',
  retryAction: 'Спробувати ще раз',
  offline: 'Офлайн – дані можуть бути неактуальні',
  queued: 'Буде надіслано після підключення',
  queueFailed: 'Не вдалося надіслати',
  sendErr: 'Не вдалося надіслати – спробувати ще раз',

  weightTitle: 'Виправлення ваги',
  weightNew: 'Нова вага (кг)',
  weightPh: 'Напр. 15,5',
  weightPhotos: 'Фото (доказ)',
  weightHint: 'Введи справжню вагу та додай фото як доказ.',
  weightSave: 'Зберегти вагу',
  errWeight: 'Введи коректну вагу.',

  routesEntry: 'Огляд маршрутів',
  routesTitle: 'Маршрути',
  routeTitle: 'Маршрут',
  routesLoading: 'Завантажую маршрути…',
  routesErr: 'Не вдалося завантажити маршрути.',
  routesForbidden: 'У тебе немає доступу до огляду маршрутів.',
  routesEmpty: 'На цей день маршрутів немає.',
  routesDay: 'День',
  routesToday: 'Сьогодні',
  routesMine: 'Мій маршрут',
  routesUnfinishedOnly: 'Лише незавершені',
  routesAll: 'Усі',
  routesUnfinishedCount: 'Незавершені',
  routeShipments: 'Відправлень',
  routeParcels: 'Пакунків',
  routeLoaded: 'Завантажено',
  routeScanned: 'Відскановано',
  routeNoDriver: 'Без водія',
  routeBack: 'Назад до маршрутів',
  routeErr: 'Не вдалося завантажити маршрут.',
  routeAllDone: 'Весь маршрут завантажено.',
  routeToLoad: 'Залишилось завантажити',
  routeUnseen: 'Не відскановано',
  routeNoUnfinished: 'Немає незавершених відправлень.',
  partialTitle: 'Частково відскановані відправлення',
  partialNoRoute: 'Без маршруту',
  partialLoading: 'Завантажую частково відскановані відправлення…',
  partialBack: 'Назад до сканування',
  partialHint: 'Замовлення, у яких відскановано лише частину посилок. Знайди відсутні та відскануй їх.',
  partialEmpty: 'Немає частково відсканованих відправлень.',
  partialErr: 'Не вдалося завантажити частково відскановані відправлення.',
  shSender: 'Відправник',
  'sh.loaded': 'ЗАВАНТАЖЕНО',
  'sh.notLoaded': 'ВІДСКАНОВАНО, НЕ ЗАВАНТАЖЕНО',
  'sh.incomplete': 'НЕ ВСЕ ВІДСКАНОВАНО І НЕ ЗАВАНТАЖЕНО',
  'sh.unknown': 'НЕВІДОМИЙ СТАН',
  shMissing: 'Бракує пакунків',

  's.preprava.kicker': 'Все гаразд',
  's.preprava.name': 'Перевезення',
  's.preprava.headline': '',
  's.preprava.sub': 'Посилка в дорозі за планом.',

  's.schvaleni.kicker': 'Очікує погодження',
  's.schvaleni.name': 'Погодження перевезення',
  's.schvaleni.headline': 'ЗАВТРА НЕ ЇДЕ',
  's.schvaleni.sub':
    'Перевезення не погоджено, посилка ще не має чіткого дня доставки. Не додавай посилку до завтрашнього маршруту.',

  's.priprava.kicker': 'Триває · підготовка',
  's.priprava.name': 'Підготовка посилки',
  's.priprava.headline': '',
  's.priprava.sub': 'Посилка завтра не їде, ймовірно буде доставлена пізніше.',

  's.vraceni.kicker': 'Поїде пізніше · повертаємо',
  's.vraceni.name': 'Повернення відправнику',
  's.vraceni.headline': '',
  's.vraceni.sub':
    'Посилка завтра не їде, ймовірно буде доставлена пізніше. Це не кінцевий стан.',

  's.dokoncena.kicker': 'Кінцевий стан · повідом диспетчера',
  's.dokoncena.name': 'Завершено',
  's.dokoncena.headline': 'ПОМИЛКА ПОСИЛКИ',
  's.dokoncena.sub': 'Замовлення вже в кінцевому стані – повідом диспетчерів.',

  's.zrusena.kicker': 'Кінцевий стан · повідом диспетчера',
  's.zrusena.name': 'Скасовано',
  's.zrusena.headline': 'ПОМИЛКА ПОСИЛКИ',
  's.zrusena.sub': 'Замовлення вже в кінцевому стані – повідом диспетчерів.',

  's.vraceno.kicker': 'Кінцевий стан · повідом диспетчера',
  's.vraceno.name': 'Повернено відправнику',
  's.vraceno.headline': 'ПОМИЛКА ПОСИЛКИ',
  's.vraceno.sub': 'Замовлення вже в кінцевому стані – повідом диспетчерів.',

  's.nenalezena.kicker': 'Коду немає в системі',
  's.nenalezena.name': 'Посилку не знайдено',
  's.nenalezena.headline': 'ПОСИЛКУ НЕ ЗНАЙДЕНО',
  's.nenalezena.sub': 'Відсканований код не знайдено в системі.',

  's.neznamy.kicker': 'Не розпізнано · перевір',
  's.neznamy.name': 'Невідомий стан',
  's.neznamy.headline': '',
  's.neznamy.sub': 'Цей стан застосунку невідомий. Не продовжуй без перевірки у диспетчера.',
};
